// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   Buttons

   Three tiers, visually distinct enough that a screen never presents two
   equally-weighted choices:

     Primary    solid brand fill, one per screen
     Secondary  outlined / tinted, supporting choices
     Tertiary   text or icon only, low-commitment actions

   Colour roles are inherited unchanged from the web: orange is the
   commercial action (Add to Cart, Checkout, Place Order), blue is
   secondary interaction. Text on either fill is navy, never white —
   white on #FF6700 is 2.8:1 and on #3B82F6 is 3.1:1, both below AA.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .btn,
html.m-app .m-btn {
  min-height: var(--m-control);
  padding: 0 var(--m-4);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-button);
  font-weight: var(--m-fw-semibold);
  letter-spacing: 0;
  gap: var(--m-2);
  /* Lift-on-hover is a pointer idiom; on touch it fires on tap and leaves
     the button hovering. Presses scale down instead, which reads as
     physical contact. */
  transition: transform var(--m-dur-fast) var(--m-ease),
              background-color var(--m-dur-fast) var(--m-ease),
              opacity var(--m-dur-fast) var(--m-ease);
}

@media (hover: none) {
  html.m-app .btn:hover {
    transform: none;
    box-shadow: none;
    background: var(--accent);
  }
}

html.m-app .btn:active,
html.m-app .m-btn:active {
  transform: scale(0.975);
}

html.m-app .btn:disabled,
html.m-app .m-btn:disabled {
  opacity: 0.45;
  transform: none;
}

/* ── Tiers ──────────────────────────────────────────────────────────────── */
html.m-app .m-btn-primary {
  background: var(--color-primary);
  color: var(--color-text-on-primary);
  border: none;
}

html.m-app .m-btn-secondary {
  background: var(--color-secondary-soft);
  color: var(--color-secondary-text);
  border: 1px solid color-mix(in srgb, var(--color-secondary) 32%, transparent);
}

html.m-app .m-btn-tertiary {
  background: transparent;
  color: var(--color-secondary-text);
  border: none;
  min-height: var(--m-touch);
  padding: 0 var(--m-2);
}

/* ── Full-width commitment actions ──────────────────────────────────────
   Continue, Save, Confirm, Submit, Checkout, Create — the actions that
   advance a flow get the full gutter-to-gutter width and the taller
   control height. */
html.m-app :is(
  .btn.submit,
  .btn-place-order,
  .pdp-add-cart-btn,
  .pdp-buy-now-btn,
  .checkout-btn,
  .settings-download-btn,
  .m-btn-block
) {
  display: flex;
  width: 100%;
  min-height: var(--m-control-lg);
  border-radius: var(--m-r-sm);
  font-size: 1rem;
  font-weight: var(--m-fw-semibold);
}

/* ── Icon button ────────────────────────────────────────────────────────── */
html.m-app .m-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--m-touch);
  height: var(--m-touch);
  min-width: var(--m-touch);
  min-height: var(--m-touch);
  padding: 0;
  border: none;
  border-radius: var(--m-r-pill);
  background: transparent;
  color: var(--color-text-primary);
}

html.m-app .m-icon-btn:active { background: var(--color-surface-hover); }

html.m-app .btn-icon,
html.m-app .modal-close {
  width: var(--m-touch);
  height: var(--m-touch);
  min-width: var(--m-touch);
  min-height: var(--m-touch);
  border-radius: var(--m-r-pill);
  font-size: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

html.m-app .modal-close svg {
  width: var(--m-icon); height: var(--m-icon);
}

html.m-app .btn-link,
html.m-app .btn-text {
  min-height: var(--m-touch);
  font-size: var(--m-fs-body);
  font-weight: var(--m-fw-medium);
  color: var(--color-secondary-text);
  padding: 0 var(--m-1);
}

html.m-app .btn-ghost {
  min-height: var(--m-control);
  border-radius: var(--m-r-sm);
  font-size: var(--m-fs-button);
  background: transparent;
  border: 1px solid var(--m-hairline-strong);
  color: var(--color-text-primary);
}

/* ── Sticky action bar ──────────────────────────────────────────────────
   Where a screen has one action that must always be reachable — Add to
   Cart on a long product page, Place Order at the end of checkout — it
   pins above the bottom nav rather than making the user scroll back.

   Sits at z-index 190, just under the nav's 200, so it can never cover
   navigation. */
html.m-app .m-sticky-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: var(--m-bottomnav-total);
  z-index: 190;
  display: flex;
  align-items: center;
  gap: var(--m-3);
  padding: var(--m-3) var(--m-gutter);
  padding-left: max(var(--m-gutter), var(--m-safe-left));
  padding-right: max(var(--m-gutter), var(--m-safe-right));
  background: var(--m-surface-bar);
  border-top: 1px solid var(--m-hairline);
  box-shadow: var(--m-shadow-sticky);
}

@supports (backdrop-filter: blur(12px)) {
  html.m-app .m-sticky-actions {
    background: color-mix(in srgb, var(--m-surface-bar) 88%, transparent);
    backdrop-filter: saturate(180%) blur(16px);
    -webkit-backdrop-filter: saturate(180%) blur(16px);
  }
}

html.m-app .m-sticky-actions .m-sticky-summary {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0;
  line-height: 1.2;
}

html.m-app .m-sticky-actions .m-sticky-label {
  font-size: var(--m-fs-caption);
  color: var(--color-text-secondary);
}

html.m-app .m-sticky-actions .m-sticky-value {
  font-size: var(--m-fs-card-title);
  font-weight: var(--m-fw-bold);
  font-variant-numeric: tabular-nums;
}

html.m-app .m-sticky-actions .btn,
html.m-app .m-sticky-actions .m-btn {
  flex: 1 1 auto;
  min-height: var(--m-control-lg);
}

/* Screens with a sticky bar reserve its height so the last card isn't
   trapped underneath it. */
html.m-app .m-has-sticky {
  padding-bottom: calc(var(--m-control-lg) + var(--m-6));
}


/* ════════════════════════════════════════════════════════════════════════
   Inline text links: hit area without visual change

   A handful of controls are text links by design — "View all" on a section
   header, "Set" beside a delivery address, the footer's legal links. They
   sit in a line of text and are 16–24px tall, which is under the 44px
   comfortable-tap floor.

   The wrong fix (and the one this layer originally shipped) is a blanket
   \`min-height\` on every button. That doesn't move the text, it just makes
   the box taller — so a 20px-wide "Set" became a 20×44 sliver, and every
   compact control in the app was stretched the same way.

   Symmetric vertical padding cancelled by an equal negative margin grows the
   hit box around the text while leaving the text exactly where it was and
   taking up no extra room in the layout. Neither class defines a
   pseudo-element, so nothing here can clobber existing content.
   ════════════════════════════════════════════════════════════════════════ */
html.m-app :is(.cat-row-viewall, .ftr-bottom-link, .pdp-change-btn, .m-tap-pad) {
  display: inline-flex;
  align-items: center;
  padding-block: 12px;
  margin-block: -12px;
  /* Same trick horizontally, for short labels like "Set" that are only ~20px
     wide. Kept smaller than the vertical pad so adjacent links in the
     footer's row can't end up with overlapping hit areas. */
  padding-inline: 8px;
  margin-inline: -8px;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/mobile/buttons.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;6EAc6E;;AAE7E;;EAEE,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf;;wBAEsB;EACtB;;qDAEmD;AACrD;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,gCAAgC;EAChC,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,6EAA6E;AAC/E;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;;oBAGoB;AACpB;;;;;;;;;EASE,aAAa;EACb,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,iCAAiC;AACnC;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,gCAAgC,sCAAsC,EAAE;;AAExE;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB,EAAE,qBAAqB;AAC7C;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;;;;;;gBAMgB;AAChB;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,sDAAsD;EACtD,wDAAwD;EACxD,gCAAgC;EAChC,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE;IACE,qEAAqE;IACrE,0CAA0C;IAC1C,kDAAkD;EACpD;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;EACd,+BAA+B;AACjC;;AAEA;2BAC2B;AAC3B;EACE,sDAAsD;AACxD;;;AAGA;;;;;;;;;;;;;;;;;6EAiB6E;AAC7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB;;4DAE0D;EAC1D,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   Buttons\n\n   Three tiers, visually distinct enough that a screen never presents two\n   equally-weighted choices:\n\n     Primary    solid brand fill, one per screen\n     Secondary  outlined / tinted, supporting choices\n     Tertiary   text or icon only, low-commitment actions\n\n   Colour roles are inherited unchanged from the web: orange is the\n   commercial action (Add to Cart, Checkout, Place Order), blue is\n   secondary interaction. Text on either fill is navy, never white —\n   white on #FF6700 is 2.8:1 and on #3B82F6 is 3.1:1, both below AA.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .btn,\nhtml.m-app .m-btn {\n  min-height: var(--m-control);\n  padding: 0 var(--m-4);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-button);\n  font-weight: var(--m-fw-semibold);\n  letter-spacing: 0;\n  gap: var(--m-2);\n  /* Lift-on-hover is a pointer idiom; on touch it fires on tap and leaves\n     the button hovering. Presses scale down instead, which reads as\n     physical contact. */\n  transition: transform var(--m-dur-fast) var(--m-ease),\n              background-color var(--m-dur-fast) var(--m-ease),\n              opacity var(--m-dur-fast) var(--m-ease);\n}\n\n@media (hover: none) {\n  html.m-app .btn:hover {\n    transform: none;\n    box-shadow: none;\n    background: var(--accent);\n  }\n}\n\nhtml.m-app .btn:active,\nhtml.m-app .m-btn:active {\n  transform: scale(0.975);\n}\n\nhtml.m-app .btn:disabled,\nhtml.m-app .m-btn:disabled {\n  opacity: 0.45;\n  transform: none;\n}\n\n/* ── Tiers ──────────────────────────────────────────────────────────────── */\nhtml.m-app .m-btn-primary {\n  background: var(--color-primary);\n  color: var(--color-text-on-primary);\n  border: none;\n}\n\nhtml.m-app .m-btn-secondary {\n  background: var(--color-secondary-soft);\n  color: var(--color-secondary-text);\n  border: 1px solid color-mix(in srgb, var(--color-secondary) 32%, transparent);\n}\n\nhtml.m-app .m-btn-tertiary {\n  background: transparent;\n  color: var(--color-secondary-text);\n  border: none;\n  min-height: var(--m-touch);\n  padding: 0 var(--m-2);\n}\n\n/* ── Full-width commitment actions ──────────────────────────────────────\n   Continue, Save, Confirm, Submit, Checkout, Create — the actions that\n   advance a flow get the full gutter-to-gutter width and the taller\n   control height. */\nhtml.m-app :is(\n  .btn.submit,\n  .btn-place-order,\n  .pdp-add-cart-btn,\n  .pdp-buy-now-btn,\n  .checkout-btn,\n  .settings-download-btn,\n  .m-btn-block\n) {\n  display: flex;\n  width: 100%;\n  min-height: var(--m-control-lg);\n  border-radius: var(--m-r-sm);\n  font-size: 1rem;\n  font-weight: var(--m-fw-semibold);\n}\n\n/* ── Icon button ────────────────────────────────────────────────────────── */\nhtml.m-app .m-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--m-touch);\n  height: var(--m-touch);\n  min-width: var(--m-touch);\n  min-height: var(--m-touch);\n  padding: 0;\n  border: none;\n  border-radius: var(--m-r-pill);\n  background: transparent;\n  color: var(--color-text-primary);\n}\n\nhtml.m-app .m-icon-btn:active { background: var(--color-surface-hover); }\n\nhtml.m-app .btn-icon,\nhtml.m-app .modal-close {\n  width: var(--m-touch);\n  height: var(--m-touch);\n  min-width: var(--m-touch);\n  min-height: var(--m-touch);\n  border-radius: var(--m-r-pill);\n  font-size: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\nhtml.m-app .modal-close svg {\n  width: var(--m-icon); height: var(--m-icon);\n}\n\nhtml.m-app .btn-link,\nhtml.m-app .btn-text {\n  min-height: var(--m-touch);\n  font-size: var(--m-fs-body);\n  font-weight: var(--m-fw-medium);\n  color: var(--color-secondary-text);\n  padding: 0 var(--m-1);\n}\n\nhtml.m-app .btn-ghost {\n  min-height: var(--m-control);\n  border-radius: var(--m-r-sm);\n  font-size: var(--m-fs-button);\n  background: transparent;\n  border: 1px solid var(--m-hairline-strong);\n  color: var(--color-text-primary);\n}\n\n/* ── Sticky action bar ──────────────────────────────────────────────────\n   Where a screen has one action that must always be reachable — Add to\n   Cart on a long product page, Place Order at the end of checkout — it\n   pins above the bottom nav rather than making the user scroll back.\n\n   Sits at z-index 190, just under the nav's 200, so it can never cover\n   navigation. */\nhtml.m-app .m-sticky-actions {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: var(--m-bottomnav-total);\n  z-index: 190;\n  display: flex;\n  align-items: center;\n  gap: var(--m-3);\n  padding: var(--m-3) var(--m-gutter);\n  padding-left: max(var(--m-gutter), var(--m-safe-left));\n  padding-right: max(var(--m-gutter), var(--m-safe-right));\n  background: var(--m-surface-bar);\n  border-top: 1px solid var(--m-hairline);\n  box-shadow: var(--m-shadow-sticky);\n}\n\n@supports (backdrop-filter: blur(12px)) {\n  html.m-app .m-sticky-actions {\n    background: color-mix(in srgb, var(--m-surface-bar) 88%, transparent);\n    backdrop-filter: saturate(180%) blur(16px);\n    -webkit-backdrop-filter: saturate(180%) blur(16px);\n  }\n}\n\nhtml.m-app .m-sticky-actions .m-sticky-summary {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  line-height: 1.2;\n}\n\nhtml.m-app .m-sticky-actions .m-sticky-label {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-secondary);\n}\n\nhtml.m-app .m-sticky-actions .m-sticky-value {\n  font-size: var(--m-fs-card-title);\n  font-weight: var(--m-fw-bold);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .m-sticky-actions .btn,\nhtml.m-app .m-sticky-actions .m-btn {\n  flex: 1 1 auto;\n  min-height: var(--m-control-lg);\n}\n\n/* Screens with a sticky bar reserve its height so the last card isn't\n   trapped underneath it. */\nhtml.m-app .m-has-sticky {\n  padding-bottom: calc(var(--m-control-lg) + var(--m-6));\n}\n\n\n/* ════════════════════════════════════════════════════════════════════════\n   Inline text links: hit area without visual change\n\n   A handful of controls are text links by design — \"View all\" on a section\n   header, \"Set\" beside a delivery address, the footer's legal links. They\n   sit in a line of text and are 16–24px tall, which is under the 44px\n   comfortable-tap floor.\n\n   The wrong fix (and the one this layer originally shipped) is a blanket\n   `min-height` on every button. That doesn't move the text, it just makes\n   the box taller — so a 20px-wide \"Set\" became a 20×44 sliver, and every\n   compact control in the app was stretched the same way.\n\n   Symmetric vertical padding cancelled by an equal negative margin grows the\n   hit box around the text while leaving the text exactly where it was and\n   taking up no extra room in the layout. Neither class defines a\n   pseudo-element, so nothing here can clobber existing content.\n   ════════════════════════════════════════════════════════════════════════ */\nhtml.m-app :is(.cat-row-viewall, .ftr-bottom-link, .pdp-change-btn, .m-tap-pad) {\n  display: inline-flex;\n  align-items: center;\n  padding-block: 12px;\n  margin-block: -12px;\n  /* Same trick horizontally, for short labels like \"Set\" that are only ~20px\n     wide. Kept smaller than the vertical pad so adjacent links in the\n     footer's row can't end up with overlapping hit areas. */\n  padding-inline: 8px;\n  margin-inline: -8px;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
